var map = {
	"./acg.png": 7516,
	"./address_image.svg": 8415,
	"./amazon_web_services_logo.jpg": 6235,
	"./animated_ashutosh.png": 4054,
	"./animated_logo.svg": 4838,
	"./arrow-black.svg": 7036,
	"./arrow-grey.svg": 1210,
	"./arrow-teal.svg": 1077,
	"./aws_logo.png": 8272,
	"./aws_partner_logo.png": 805,
	"./blogs_image.svg": 1108,
	"./cloud_infrastructure.svg": 5820,
	"./codeInLogo.png": 9384,
	"./comptia_logo.svg": 5738,
	"./contactMail.png": 3914,
	"./coursera_logo.png": 8857,
	"./data_science.svg": 8712,
	"./deeplearning_ai_logo.png": 774,
	"./delhivery_logo.png": 7311,
	"./deloitte_logo.jpg": 3581,
	"./developerActivity.svg": 9504,
	"./dsc_logo.png": 3979,
	"./education.svg": 1803,
	"./experience.svg": 1071,
	"./feelingProud.svg": 2677,
	"./freecopy_logo.png": 1434,
	"./fullstack.svg": 1272,
	"./ga_logo.png": 5017,
	"./gcp_logo.png": 4375,
	"./github_logo.png": 9214,
	"./googleAssistant.jpg": 3440,
	"./googleAssistant.svg": 9650,
	"./google_logo.png": 6038,
	"./ibm_logo.png": 5539,
	"./iiitk_logo.png": 2837,
	"./intel_logo.jpg": 1021,
	"./iot-inc_logo.png": 1072,
	"./iu_logo.png": 8291,
	"./jsFramework.svg": 4406,
	"./keeper_security_logo.jpg": 6792,
	"./legato_logo.png": 7147,
	"./manOnTable.svg": 3350,
	"./microsoft_logo.png": 3953,
	"./mozilla_logo.png": 9105,
	"./muffito_logo.png": 3981,
	"./nextuLogo.jpg": 8846,
	"./nptel_logo.png": 3862,
	"./piskel_selfie_144.png": 9972,
	"./portfolio.gif": 7888,
	"./profile_pic.jpeg": 5982,
	"./programmer.svg": 2075,
	"./projects_image.svg": 5739,
	"./pwa.png": 7399,
	"./saayaHealthLogo.png": 4123,
	"./scaled_agile_logo.png": 1800,
	"./scrum_alliance.svg": 8505,
	"./stanford_logo.png": 4216,
	"./steamdinc_logo.jpg": 1517,
	"./talksCardBack.svg": 7175,
	"./talksCardBackAlt.svg": 6740,
	"./teksystems_logo.jpg": 2735,
	"./tflagship_logo.jpg": 6433,
	"./tiktok_logo.png": 7427,
	"./udemy_logo.png": 439,
	"./ui_ux_design.svg": 7880,
	"./vt_logo.png": 6147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;